import React, { useState } from "react";
import {
  Card,
  CardHeader,
  Typography,
  Grid,
  Divider,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";

const ProductThumbnails = ({ images, productName }) => {
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleOpen = (index) => {
    setSelectedIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrev = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <>
      <Card elevation={3} sx={{ padding: 3, maxWidth: 900 }}>
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              align="center"
              sx={{ mb: 2 }}
            >
              Product Thumbnails
            </Typography>
          }
        />
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {images.map((img, index) => {
            const imgSrc = `https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/productImages/${img.product_image_path}`;
            return (
              <Grid item xs={6} sm={4} md={3} key={img.id || index}>
                <img
                  src={imgSrc}
                  alt={`Product ${productName}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpen(index)}
                />
              </Grid>
            );
          })}
        </Grid>
      </Card>

      {/* Enlarged Image Dialog with Lighter Background */}
      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullScreen>
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            bgcolor: "rgba(255, 255, 255, 0.7)",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              color: "black",
              background: "rgba(255, 255, 255, 0.6)",
              "&:hover": { background: "rgba(255, 255, 255, 0.8)" },
            }}
          >
            <Close fontSize="large" />
          </IconButton>

          {/* Left Arrow Outside Box */}
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 50,
              top: "50%",
              transform: "translateY(-50%)",
              color: "black",
              background: "rgba(255, 255, 255, 0.6)",
              padding: "20px",
              "&:hover": { background: "rgba(255, 255, 255, 0.8)" },
            }}
          >
            <ArrowBackIos fontSize="large" />
          </IconButton>

          {/* Enlarged Image */}
          <img
            src={`https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/productImages/${images[selectedIndex].product_image_path}`}
            alt="Enlarged Product"
            style={{
              width: "80%",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: "10px",
            }}
          />

          {/* Right Arrow Outside Box */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 50,
              top: "50%",
              transform: "translateY(-50%)",
              color: "black",
              background: "rgba(255, 255, 255, 0.6)",
              padding: "20px",
              "&:hover": { background: "rgba(255, 255, 255, 0.8)" },
            }}
          >
            <ArrowForwardIos fontSize="large" />
          </IconButton>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ProductThumbnails;
